<template>
	<div>
		<b-breadcrumb>
			<b-breadcrumb-item text="Home" to="/"/>
			<b-breadcrumb-item text="Servers" to="/servers"/>
			<b-breadcrumb-item text="New Server" :active="true"/>
		</b-breadcrumb>
		<b-container>
			<b-row>
				<b-col>
					<b-form @submit="addServer">
						<b-row>
							<b-col lg="6" md="6" sm="12" xs="12">
								<b-form-group id="name-group" label="Name:" label-for="name" description="Enter the name of the server">
									<b-form-input id="name" type="text" v-model="server.name" autofocus required placeholder="Enter server name"></b-form-input>
								</b-form-group>
							</b-col>
							<b-col lg="6" md="6" sm="12" xs="12">
								<b-form-group id="color-group" label="Color:" label-for="color" description="Color for display">
									<b-form-input id="color" type="color" v-model="server.color" required placeholder="Select color"></b-form-input>
								</b-form-group>
							</b-col>
						</b-row>
						<b-row>
							<b-col lg="6" md="6" sm="12" xs="12">
								<b-form-group id="hostname-group" label="Hostname:" label-for="hostname" description="Server Hostname or IP Address">
									<b-form-input id="hostname" type="text" v-model="server.hostname" required placeholder="Enter server hostname or IP address"></b-form-input>
								</b-form-group>
							</b-col>
							<b-col lg="6" md="6" sm="12" xs="12">
								<b-form-group id="port-group" label="Port:" label-for="port" description="Server Port (default 4444)">
									<b-form-input id="port" type="text" v-model="server.port" required placeholder="Enter server port"></b-form-input>
								</b-form-group>
							</b-col>
						</b-row>
						<b-row>
							<b-col>
								<b-form-group label="Group:" label-for="name" description="Enter the server group">
									<b-form-input type="text" v-model="server.group" autofocus required placeholder="Enter server group"></b-form-input>
								</b-form-group>
							</b-col>
						</b-row>
						<b-row>
							<b-col>
								<b-form-group id="description-group" label="Description:" label-for="description" description="Server Description">
									<b-form-textarea id="description" type="text" v-model="server.description" placeholder="Enter Description" rows="5"></b-form-textarea>
								</b-form-group>
							</b-col>
						</b-row>
						<b-row>
							<b-col class="d-flex justify-content-end">
								<b-button-group>
									<b-button type="Submit" variant="primary">Add</b-button>
									<b-button @click="cancel()">Cancel</b-button>
								</b-button-group>
							</b-col>
						</b-row>
					</b-form>
				</b-col>
			</b-row>
		</b-container>
	</div>
</template>
<script>
import {HTTP} from '../../services/HttpService'

export default {
  name: 'server',
  data: () => ({
    server: {
      name: null,
      hostname: null,
      port: 4444,
      color: null,
      group: null,
      description: null
    }
  }),
  methods: {
    addServer (event) {
      event.preventDefault()
      const formData = new FormData()
      formData.append('name', this.server.name)
      formData.append('hostname', this.server.hostname)
      formData.append('port', this.server.port)
      formData.append('color', this.server.color)
      formData.append('group', this.server.group)
      formData.append('description', this.server.description)
      HTTP.post('servers', formData)
        .then(response => {
          this.$router.push({
            name: 'ServersPage'
          })
        })
    },
    cancel () {
      this.$router.push({
        name: 'ServersPage'
      })
    }
  },
  created () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// AddServerPage.vue?07b803f4